var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import api from '@utils/axios';
const base = (inspectionId) => `/api/internal/inspections/${inspectionId}/inspection_attachments`;
function buildFormData(form, includeFile = true) {
    var _a;
    const body = new FormData();
    if (includeFile && form.file)
        body.append('inspection_attachment[attachment]', form.file);
    body.append('inspection_attachment[name]', form.name);
    body.append('inspection_attachment[technician_name]', form.technicianName);
    body.append('inspection_attachment[certification_number]', form.certificationNumber);
    body.append('inspection_attachment[show_on_report]', String(form.showOnReport));
    body.append('inspection_attachment[include_in_cover_letter]', String(form.includeInCoverLetter));
    // Always send answer (empty string clears it back to "None"); omitting it left a FAIL value stuck.
    body.append('inspection_attachment[answer]', (_a = form.answer) !== null && _a !== void 0 ? _a : '');
    return body;
}
export function getInspectionAttachments(inspectionId) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield api.get(base(inspectionId));
        return data;
    });
}
export function createInspectionAttachment(inspectionId, form) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield api.post(base(inspectionId), buildFormData(form));
        return data;
    });
}
export function updateInspectionAttachment(inspectionId, attachmentId, form) {
    return __awaiter(this, void 0, void 0, function* () {
        const url = `${base(inspectionId)}/${attachmentId}`;
        if (form.file) {
            const { data } = yield api.patch(url, buildFormData(form));
            return data;
        }
        const { data } = yield api.patch(url, {
            inspection_attachment: {
                name: form.name,
                technician_name: form.technicianName,
                certification_number: form.certificationNumber,
                show_on_report: form.showOnReport,
                include_in_cover_letter: form.includeInCoverLetter,
                // Always send answer so None (null) can be saved; omitting it left a FAIL value stuck.
                answer: form.answer
            }
        });
        return data;
    });
}
export function deleteInspectionAttachment(inspectionId, attachmentId) {
    return __awaiter(this, void 0, void 0, function* () {
        yield api.delete(`${base(inspectionId)}/${attachmentId}`);
    });
}
